import { Field, Toggle } from '@zendeskgarden/react-forms'
import type { ZenToggleProps } from './interface'

export function ZenToggle({
  label,
  checked,
  defaultChecked,
  disabled,
  onChange,
}: ZenToggleProps) {
  return (
    <Field>
      <Toggle
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked)}
      >
        <Field.Label hidden={!label}>{label ?? 'Toggle'}</Field.Label>
      </Toggle>
    </Field>
  )
}
